import { Button, Popconfirm } from 'antd';
import { useTranslation } from 'react-i18next';

export interface IIntegrationConfirmButtonProps {
  onConfirm: () => void;
}

/**
 * Pulsante per confermare e avviare l'integrazione
 */
export function IntegrationConfirmButton(
  props: IIntegrationConfirmButtonProps,
) {
  const { onConfirm } = props;
  const { t } = useTranslation();

  return (
    <Popconfirm
      onConfirm={onConfirm}
      title={t(
        'submission-integration-button.sicuro-avviare-integrazione',
        "Sicuro di voler avviare l'integrazione?",
      )}
      okText={t('submission-integration-button.avvia', 'Avvia')}
    >
      <Button type="primary" size="large" onClick={e => e.stopPropagation()}>
        {t(
          'submission-integration-button.integra-la-richiesta',
          'Integra la Richiesta',
        )}
      </Button>
    </Popconfirm>
  );
}
